import { useState } from "react";
import { saveReportingWbsDetails } from "../Api/ReportingWbs";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const ReportingWbsReport = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId; 

  const [wbsData, setWbsData] = useState({
    wbsCode: "",
    operationalReportHead: "",
    orgPerformance: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setWbsData({
      ...wbsData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveReportingWbsDetails(wbsData, userId);
      toast.success(`🦄 Reporting WBS Added Successfully`);
      setWbsData({
        wbsCode: "",
        operationalReportHead: "",
        orgPerformance: ""
      });
    } catch (error) {
      toast.error(`🦄 Error: ${error.message || "Failed to save reporting WBS details"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Reporting WBS Report</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Reporting WBS Code <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="wbsCode"
                      value={wbsData.wbsCode}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Operational Report Head <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="operationalReportHead"
                      value={wbsData.operationalReportHead}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Org Performance <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="orgPerformance"
                      value={wbsData.orgPerformance}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Reporting WBS
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default ReportingWbsReport;